import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import "./App.css";
import Loader from "./components/Loader";
// import Mouse from "./components/Mouse";
import Header from "./components/Header/Header";
import Offcanvas from "./components/Offcanvas";
import BacktoTop from "./components/BacktoTop";
import Footer from "./components/Footer";
import Top from "./components/Top";
import NotFound from "./components/NotFound";

import { WOW } from "wowjs";
import "animate.css";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import BusinessPortfolio from "./pages/BusinessPortfolio/BusinessPortfolio";
import Gallery from "./pages/Gallery/Gallery";
import CSR from "./pages/CSR/CSR";
import Product from "./pages/Product/Product";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import NetRoop from "./pages/NetRoop/NetRoop";
import ChairmanMessage from "./pages/About/ChairmanMessage";
import MessageMD from "./pages/About/MessageMD";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // WOW Animation
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animate__animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  }, []);

  // Loader
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <Top />
      {/* <Mouse /> */}
      <Header toggleMenu={toggleMenu} />
      <Offcanvas closeMenu={closeMenu} menuOpen={menuOpen} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Product />} />
          <Route
            path="/products/product-details/:id"
            element={<ProductDetails />}
          />

          {/* Net & Rope */}
          <Route path="/fishing-net" element={<NetRoop />} />
          <Route path="/agri_net" element={<NetRoop />} />
          <Route path="/garden_net" element={<NetRoop />} />
          <Route path="/build_net" element={<NetRoop />} />
          <Route path="/pp-rope" element={<NetRoop />} />
          <Route path="/hdpe-rope" element={<NetRoop />} />

          <Route path="/business-portfolio" element={<BusinessPortfolio />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/csr" element={<CSR />} />
          <Route path="/news" element={<Blog />} />
          <Route path="/news/news-details/:id" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/chairman-msg" element={<ChairmanMessage />} />
          <Route path="/md-msg" element={<MessageMD />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <BacktoTop />
    </BrowserRouter>
  );
}

export default App;
